module.exports = __webpack_public_path__ + "static/media/x.992c0da7.svg";